import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { mod } from "ngx-bootstrap/bs-moment/utils";
import { Order } from "../../../objects/orders/order";
import { NgForm } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap";
import { CBP3461, DocumentProperty } from "../../../objects/documents/CBP3461";
import * as ps from "perfect-scrollbar";
import { DocumentService } from "../../../services/documentService";
import { LineInformationComponent3461 } from "./document-blocks/line-information.component-3461";
import { HeaderInfo3461Component } from "./document-blocks/header-info-3461.component";
import { HeaderParties3461Component } from "./document-blocks/header-parties-3461.component";
import { CertificationInfo3461Component } from "./document-blocks/certification-info-3461.component";
import { BillOfLanding3461Component } from "./document-blocks/bill-of-landing-3461.component";
import { HScodeHelper } from "../../../common/helpers/HScodeHelper";
import { forEach } from "@angular/router/src/utils/collection";
import { SortType } from "../../../objects/users/user";
import { PropertyHelper } from "../../../common/helpers/propertyHelper";
import { ScrollHelper } from "../../../common/helpers/scrollHelper";
import { ScreenHelper } from "../../../common/helpers/screenHelper";


@Component({
    selector: 'document-3461',
    templateUrl: 'document-3461.component.html',
    moduleId: module.id.toString()
})
export class Document3461Component {
    @ViewChild('documentModal')
    public documentModal: ModalDirective;

    @ViewChild("documentForm")
    public documentForm: NgForm;

    @ViewChild('documentModalRef')
    public documentModalRef: ElementRef;

    @ViewChild(LineInformationComponent3461)
    public lineInformation3461: LineInformationComponent3461;

    @ViewChild(HeaderInfo3461Component)
    public headerInfo3461Component: HeaderInfo3461Component;

    @ViewChild(HeaderParties3461Component)
    public headerParties3461Component: HeaderParties3461Component;

    @ViewChild(CertificationInfo3461Component)
    public certificationInfo3461Component: CertificationInfo3461Component;

    @ViewChild(BillOfLanding3461Component)
    public billOfLanding3461Component: BillOfLanding3461Component;

    @Input()
    public order: Order;

    @ViewChild('saveBtn')
    public saveBtn: ElementRef;

    @ViewChild('closeBtn')
    public closeBtn: ElementRef;

    public processing: boolean = false;

    public document: CBP3461 = new CBP3461();

    public isFormSubmitted: boolean = false;

    @Output()
    public documentModified: EventEmitter<CBP3461> = new EventEmitter<CBP3461>();

    public constructor(private documentService: DocumentService) {

    }

    public show(document: CBP3461 = new CBP3461()): void {
        //TODO send request for the new empty object or for edit object
        this.document = document;
        this.documentModal.show();

    }

    public ngOnInit(): void {
        ps.initialize(this.documentModalRef.nativeElement);
    }

    public isDocumentValid(): boolean {
        if (!this.certificationInfo3461Component || !this.lineInformation3461 ||
            !this.headerInfo3461Component || !this.headerParties3461Component || !this.billOfLanding3461Component) {
            return false;
        }

        return (this.certificationInfo3461Component.isFormValid() && this.lineInformation3461.isFormValid() &&
            this.headerInfo3461Component.isFormValid() && this.headerParties3461Component.isFormValid() && this.billOfLanding3461Component.isFormValid());

    }

    public onScroll(scrollY: any): void {
        ScrollHelper.stickyElementOnScroll(scrollY, [this.saveBtn.nativeElement, this.closeBtn.nativeElement], 150);
    };

    public closeDocumentModal(hideModal: boolean): void {
        this.lineInformation3461.lineInformationForm.resetForm();
        this.headerInfo3461Component.headerInfoForm.resetForm();
        this.headerParties3461Component.headerPartiesForm.resetForm();
        this.certificationInfo3461Component.certificationInfoForm.resetForm();
        this.billOfLanding3461Component.billOfLandingForm.resetForm();

        this.isFormSubmitted = false;

        if (hideModal)
            this.documentModal.hide()
    }

    public save(): void {
        this.lineInformation3461.submitFormAndValidity();
        this.headerInfo3461Component.submitFormAndValidity();
        this.headerParties3461Component.submitFormAndValidity();
        this.certificationInfo3461Component.submitFormAndValidity();
        this.billOfLanding3461Component.submitFormAndValidity();

        if (!this.isDocumentValid()) {
            this.isFormSubmitted = true;
            return;
        }

        this.document.OrderId = this.order.Id;
        this.document.Created = new Date();
        this.document.Name = 'CBP3461'; // TODO this shit

        this.documentService.save<CBP3461>(this.document, 'CBP3461').then((resp: any) => {

                this.document = resp.Data;

                let firstBillOfLanding = resp.Data.FirstBillOfLanding;
                let secondBillOfLanding = resp.Data.SecondBillOfLanding;

                let isValid = PropertyHelper.isPropsValid(resp.Data) && PropertyHelper.isPropsValid(firstBillOfLanding) && PropertyHelper.isPropsValid(secondBillOfLanding);

                if (isValid) {
                    this.processing = false;
                    this.closeDocumentModal(true);
                    this.documentModified.emit(resp);
                }

            }
        );
    }

}



// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-3461/document-3461.component.ts